<template>
  <base-message :message="message">
    <div class="message-body choice-message">
      <label><b class="is-text-rsmall is-text-info">选择题</b></label>
      <choice :problem="message.data"
              @correct="next"></choice>
    </div>
  </base-message>
</template>

<script>
  // import LoadingDot from './LoadingDot'
  import BaseMessage from './BaseMessage'
  import Choice from '../../../common/problem/Choice.vue'
  import IClassroom from '@/components/classroom/lib/IClassroom'

  export default {
    components: { BaseMessage, Choice },
    props: ['message'],
    data () {
      return {
        IClassroom
      }
    },
    methods: {
      next () {
        IClassroom.requestNextMessage(1000)
      }
    }
  }
</script>

<style lang="stylus" scoped>
</style>
